var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1477,
    height: 1244,
    viewBox: "0 0 1477 1244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2847_348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3371 511.514H0V326.84H184.674V419.177H277.011V511.514H369.348V603.851H461.686V696.188H554.023V788.525H646.36V906.743H831.034V788.525H923.371V696.188H1015.71V603.851H1108.05V511.514H1200.38V419.177H1292.72V326.84H1477.39V511.514H1385.06V603.851H1292.72V696.188H1200.38V788.525H1108.05V880.862H1015.71V973.2H923.371V1065.54H831.034V1157.87H646.36V1065.54H554.023V973.2H461.686V880.862H369.348V788.525H277.011V696.188H184.674V603.851H92.3371V511.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.682 0H369.345H277.008L277.008 92.3371V184.674H369.345V277.011H461.682V369.348H554.019V461.685H646.356V554.023H831.031V461.685H923.368V369.348H1015.7V277.011H1108.04V184.674H1200.38V92.3371L1200.38 0H1108.04H1015.7V92.3371H923.368V184.674H831.031V302.892H646.356V184.674H554.019V92.3371H461.682V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2847_348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1477,
    height: 1244,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/download_arrow.8b1c7c824372577e7b014006f890d0f6.svg";
export { ForwardRef as ReactComponent };